import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, effect, inject, signal } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { SessionInactivityService } from '../../../../core/auth/session-inactivity.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { InactivityWarningSnackbarComponent } from '../inactivity-warning-snackbar/inactivity-warning-snackbar.component';

@Component({
    selector: 'app-protected-layout',
    standalone: true,
    imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent],
    templateUrl: './protected-layout.component.html',
    styleUrls: ['./protected-layout.component.scss']
})
export class ProtectedLayoutComponent implements OnInit {
    private readonly inactivityService = inject(SessionInactivityService);
    private readonly snackBar = inject(MatSnackBar);

    private snackBarRef: MatSnackBarRef<InactivityWarningSnackbarComponent> | null = null;
    private readonly isWarningDisplayed = signal(false);

    constructor() {
        effect(() => {
            const isWarning = this.inactivityService.isWarningActive();

            if (isWarning && !this.isWarningDisplayed()) {
                this.isWarningDisplayed.set(true);
                this.snackBarRef = this.snackBar.openFromComponent(InactivityWarningSnackbarComponent, {
                    duration: 0,
                    horizontalPosition: 'center',
                    verticalPosition: 'bottom',
                    panelClass: ['inactivity-warning-snackbar'],
                    data: {
                        service: this.inactivityService,
                        onDismiss: () => this.handleSnackbarDismiss()
                    }
                });
            } else if (!isWarning && this.isWarningDisplayed()) {
                this.handleSnackbarDismiss();
            }
        });
    }

    ngOnInit(): void {
        this.inactivityService.startTracking();
    }

    @HostListener('mousemove')
    @HostListener('keydown')
    @HostListener('click')
    onActivity(): void {
        this.inactivityService.resetActivity();
    }

    private handleSnackbarDismiss(): void {
        if (this.snackBarRef) {
            this.snackBarRef.dismiss();
            this.snackBarRef = null;
        }

        this.isWarningDisplayed.set(false);
    }
}
